import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { createUseStyles } from 'react-jss';
import { LogoWithText } from '@sm/webassets';
import { generateMetricsAttribute } from '@sm/metrics';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Button } from '@wds/button';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const COPY = defineMessages({
  THANK_YOU: {
    id: 'SurveyThanks.Embedded.ThankYou',
    defaultMessage: 'Thank you for taking the survey.',
    description:
      '[Type: Header][vis: high] - The primary message on the webpage. Used to say thank you to survey respondents and signal the end of the survey.',
  },
  POWERED_BY: {
    id: 'SurveyThanks.Embedded.PoweredBy',
    defaultMessage: 'powered by',
    description:
      '[Type: Label][Vis: med] - This figure of speech is used to introduce and display the SurveyMonkey Logo',
  },
  EMBEDDED_CTA: {
    id: 'SurveyThanks.Embedded.EmbeddedCTA',
    defaultMessage: 'Learn More',
    description:
      '[Type: Label][Vis: med] - This is the phrase used inside a button that directs views to a signup page',
  },
  EMBEDDED_CTA_TITLE: {
    id: 'SurveyThanks.Embedded.EmbeddedCTATitle',
    defaultMessage: 'Learn More About SurveyMonkey',
    description:
      '[Type: Label][Vis: low] - This text is here for accessibility reasons, it is usually hidden from users.',
  },
});

const useStyles = createUseStyles((theme: CmsWrenchTheme) => {
  return {
    embeddedContainer: {
      height: theme.util.fullHeight,
    },
    thankYouMessage: {
      paddingBottom: theme.spacing[4],
      fontWeight: 700,
    },
    logoWithText: {
      height: 23,
      padding: theme.spacing[4],
    },
  };
});

function Embedded(): React.ReactElement {
  const classes = useStyles();
  const utSource = 'survey_thanks';
  const utSource2 = 'embedded';

  return (
    <Box
      className={classes.embeddedContainer}
      display="flex"
      flexAlign="center"
      flexJustify="center"
      flexDirection="column"
    >
      <Box>
        <Typography component="div" variant="cardTitle" className={classes.thankYouMessage}>
          {t(COPY.THANK_YOU)}
        </Typography>
      </Box>
      <Box>
        <Typography component="span" variant="bodySm" color="darkMuted">
          {t(COPY.POWERED_BY)}
        </Typography>
      </Box>
      <Box>
        <LogoWithText className={classes.logoWithText} />
      </Box>
      <Box>
        <Button
          color="muted"
          size="sm"
          title={t(COPY.EMBEDDED_CTA_TITLE)}
          href={createURL('/user/sign-up/', {
            ut_source: utSource,
            ut_source2: utSource2,
          })}
          data-sm-metric={generateMetricsAttribute({
            data: {
              actionType: `${utSource}_click_${utSource2}_cta_to_sign_up`,
              actionFlow: { utSource },
            },
          })}
        >
          {t(COPY.EMBEDDED_CTA)}
        </Button>
      </Box>
    </Box>
  );
}

export default Embedded;
